import type {
  Region,
  User_KarrotScore,
  User_ScoreBadge,
} from "@daangn/idl/rocketchat/api/model";

import {
  User_IdentificationStatus,
  User_Role,
  User_Type,
} from "@daangn/idl/rocketchat/api/model";
import { Entity } from "@data-client/endpoint";
import type { UserID } from "../types";

export class User extends Entity {
  /**
   * @example
   * alpha-ca 기준
   * 2895: esther park
   * 2581: levi
   * 3430: tony
   * 3431: lucas.han
   */
  id: UserID = "";
  type = User_Type.TYPE_UNSPECIFIED;
  nickname = "";
  profile_image = "";
  /** Message 응답시간 */
  message_response_time = "";
  /** 방해금지 설정 여부 */
  is_do_not_disturb_on = false;
  /** 방해금지 설정 시작 시간 */
  do_not_disturb_start_time = "";
  /** 방해금지 설정 종료 시간 */
  do_not_disturb_end_time = "";
  /** 뱃지 이미지 URL */
  badge_image = "";
  /** 나의 액션에 의해 해당 유저에게 설정된 플래그.
   * @example ["UserBlock"]
   */
  user_flagged_by_me: string[] = [];
  /** 사용자 계정 상태 */
  status = "";
  /** 유저 정보를 보기 위해 이동할 딥링크 */
  target_uri = "";
  /** 지역 인증 횟수 */
  display_region_checkins_count = 0;
  /** 유저의 타임존 */
  do_not_disturb_time_zone = "";
  /**
   * 오피셜 계정인지 여부. e.g) 당근이, 광고주센터 등.
   * Receiver 정보일 때만 확인할 수 있다.
   */
  is_official_user = false;
  /** H3 기반의 유저의 지역 정보 */
  display_location_name = "";
  /** 비즈 유저의 단골 여부 */
  is_biz_follower = false;
  /** 글로벌에서 같은 콘도에 있는 유저인지 여부 */
  is_same_condo_member = false;
  /**
   * 멤버의 닉네임 옆에 괄호로 표시되는 부가 정보
   * ex) (401호), (별명)
   */
  subnickname = "";
  /** 멤버의 역할 */
  role = User_Role.ROLE_UNSPECIFIED;
  /** User 인증 정보 */
  identification_status =
    User_IdentificationStatus.IDENTIFICATION_STATUS_UNSPECIFIED;
  /** 기존 매너 온도 */
  manner_temperature?: number | undefined = undefined;
  /** 세 자리 정수 Karrot score */
  karrot_score?: User_KarrotScore | undefined = undefined;
  /** ScoreBadge */
  score_badge?: User_ScoreBadge | undefined = undefined;
  /** 지역 */
  region?: Region | undefined = undefined;

  static key = "User";

  static process(value: User, parent: Entity, key: string, args: unknown[]) {
    // biome-ignore lint/complexity/noThisInStatic:
    const processed = super.process(value, parent, key, args);
    return {
      ...(User.defaults ?? {}),
      ...processed,
    };
  }
}
